<app-booking-navbar [step]="4"></app-booking-navbar>

<div class="row mt-3" *ngIf="(basket$ | async)">
    <div class="col-12 text-right">
            <button class="btn btn-sm  btn-primary" (click)="continue()">Continue</button>
    </div>
</div>

<div class="row">
    <div class="col-12 col-md-3">
        <div class="mt-3" *ngIf="(basket$ | async)">
            <app-trb-basket [basketItem]="(basket$ | async).items[itemIdx]" [basketItemIdx]="itemIdx" [allowDelete]="true"></app-trb-basket>
        </div>

    </div>

    <div class="col-12 col-md-9">
<mat-card class="mb-3 mt-3">
        <div class="faq-page">
            <!-- <p class="section-title mb-16">Why not treat yourself!</p> -->

            <!-- <div class="mb-2" *ngIf="step !== 'complete'">
                <div class="row">
                    <div class="col-12 text-right">
                        <i class="fa fa-shopping-basket text-primary"></i> {{basket.items.length}} treatment<span *ngIf="basket.items.length !== 1">s</span> selected
                        <a *ngIf="basket.items.length && step === 'treatments'" class="btn btn-primary ml-3" (click)="viewBasket()">
                            Continue
                        </a>
                    </div>
                </div>
            </div> -->

            <!-- <app-basket [basket]="basket" [dates]="dates" (setStep)="setStep($event)" *ngIf="step === 'basket'"></app-basket>
            <app-customer-details [basket]="basket" (setStep)="setStep($event)" *ngIf="step === 'customer'"></app-customer-details>
            <app-spa-payment [basket]="basket" (setStep)="setStep($event)" *ngIf="step === 'payment'"></app-spa-payment>
            <app-spa-booking-complete (setStep)="setStep($event)" *ngIf="step === 'complete'"></app-spa-booking-complete> -->

            <ng-container *ngIf="step === 'treatments'">
                <div class="row mt-1">
                    <div class="col-12 col-lg-3">
                        <select
                            class="form-control d-lg-none d-xl-none mb-4"
                            [(ngModel)]="categorySelected"
                            (ngModelChange)="categorySelectedChange()">

                            <option [value]="category.id" *ngFor="let category of trbCategories">
                                {{category.name}}
                            </option>
                        </select>

                        <div class="d-none d-lg-block" *ngFor="let category of trbCategories">
                            <p class="mat-title mb-2">
                                <a class="hover" (click)="getTrbOfferings(category.id)">{{category.name}}</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-9">
                        <div class="row">
                            <ng-container *ngFor="let offering of offerings">
                                <div class="col-12 col-lg-6 col-md-6" *ngIf="offering.type === 'appointment'">
                                    <div class="tile" (click)="viewOffering(offering)">
                                        <div *ngIf="offering.image" class="image-tile" [ngStyle]="{'background-image': 'url(' + offering.image.url + ')'}"></div>
                                        <div *ngIf="!offering.image" class="image-tile" [ngStyle]="{'background-color': 'background-color: rgb(209 213 219/0.5)'}"></div>
                                        <div class="overview">
                                            <p class="mat-subtitle mb-1">{{offering.name}}</p>
                                            <p class="mat-subtitle mb-1">From {{(offering.price_from / 100) | currency : 'GBP'}}</p>
                                            <p class="mb-1" *ngIf="offering.duration">Lasts {{offering.duration}} minutes</p>
                                        </div>
                                    </div>
                                    <!-- <img *ngIf="offering.image" style="width: 100%;" [src]="offering.image.url" /> -->
                                </div>
                            </ng-container>
                        </div>

                    </div>

                </div>
            </ng-container>


        </div>

</mat-card>




    </div>
</div>


